import * as Yup from 'yup';

export const validateModel = Yup.object().shape({

    nombre: Yup.string().required('Campo obligatorio'),
    imagen: Yup.object().required('Campo obligatorio'),   
})